import LoginForm from "../../components/LoginForm/LoginForm";
import LoginFormPageStyles from "./LoginFormPageStyles";

const LoginFormPage = (): JSX.Element => {
  return (
    <LoginFormPageStyles>
      <LoginForm />
    </LoginFormPageStyles>
  );
};

export default LoginFormPage;
